import React, { useState, useEffect } from "react";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import search from "../../Assets/icons/Search.svg";
import bgImg from "../../Assets/images/bgImg.jpg";
import book1 from "../../Assets/images/book1.png";
import book2 from "../../Assets/images/book2.png";
import book3 from "../../Assets/images/book3.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { websiteUrl } from "../../const/constants";

const Mutabaat = () => {
  const navigate = useNavigate();
  const [aboutIntro, setAboutIntro] = useState(null);
  const [aboutLoading, setAboutLoading] = useState(true);
  useEffect(() => {
    setAboutLoading(true);
    axios
      .get(`${websiteUrl}/api/about?section_key=mutabaat_intro&active=1`)
      .then((res) => {
        if (res.data.success && res.data.data && res.data.data.length > 0) {
          setAboutIntro(res.data.data[0]);
        } else {
          setAboutIntro(null);
        }
        setAboutLoading(false);
      })
      .catch(() => {
        setAboutIntro(null);
        setAboutLoading(false);
      });
  }, []);
  return (
    <>
      <Header />
      <div
        dir="rtl"
        className="bg-white min-h-screen w-full mt-28 px-5 sm:px-10 md:px-10 lg:px-20 text-black text-center font-nastaleeqRegular font-normal mb-6"
      >
        {/* Relative container for proper layout flow */}
        <div className="relative pb-[300px]">
          {/* Hero Section */}
          <div
            style={{ backgroundImage: `url(${bgImg})` }}
            className="bg-cover bg-center h-[450px] w-full flex items-center justify-center rounded-xl transition-all duration-300 hover:shadow-lg"
          >
            <div className="p-6 rounded-3xl bg-white flex lg:flex-row flex-col gap-[10px] md:gap-8 transition-all duration-300 hover:shadow-lg">
              <div className="px-6 py-4 bg-[#F2F4F8] flex items-center rounded-xl lg:w-[410px] transition-all duration-300">
                <img
                  src={search}
                  alt="Search"
                  className="size-5 ml-3 lg:ml-2 transition-transform duration-300 hover:scale-110"
                />
                <input
                  type="text"
                  placeholder="مضمون کا نام یا مطلوبہ الفاظ..."
                  className="lg:h-[58px] rounded-xl bg-[#F2F4F8] outline-none placeholder:text-lg placeholder:sm:text-xl placeholder:md:text-2xl placeholder:lg:text-2xl w-full transition-all duration-300"
                />
              </div>
              <div className="px-6 py-4 bg-[#F2F4F8] flex items-center rounded-xl lg:w-[410px] border border-[#F2F4F8] transition-all duration-300 hover:bg-white hover:ring-2 hover:ring-primary">
                <select className="w-full bg-[#F2F4F8] outline-none text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda transition-all duration-300">
                  <option>تمام زمرے</option>
                </select>
              </div>
              <button className="px-6 py-4 rounded-xl lg:w-[170px] text-white bg-primary font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl transition-all duration-300 hover:bg-primary/90 hover:scale-105 hover:shadow-lg">
                تلاش کریں۔
              </button>
            </div>
          </div>

          {/* Books Section (Responsive with Absolute Positioning) */}
          <div className="absolute flex items-center justify-center py-3 top-[380px] left-1/2 transform -translate-x-1/2 gap-6 z-20">
            {[book1, book2, book3].map((book, index) => (
              <div
                key={index}
                className="flex flex-col gap-[10px] cursor-pointer w-[90px] sm:w-[180px] md:w-[150px] lg:w-[220px] xl:w-[240px] transition-all duration-300 hover:scale-105"
                onClick={() => {
                  navigate("/tableeghat/bookDetail");
                }}
              >
                <img
                  src={book}
                  alt={`Book ${index + 1}`}
                  className="rounded-xl transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
                  loading="lazy"
                />
                <p className="text-center text-xl sm:text-2xl md:text-2xl lg:text-3xl hover:text-primary transition-all duration-300">
                  عصر غیبت کی ذمہ داریاں
                </p>
                <p className="text-center text-lg sm:text-xl md:text-xl lg:text-2xl text-[#999FAA] transition-all duration-300 hover:text-primary/80">
                  مصنف کا نام
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Dynamic About Intro */}
        {aboutLoading ? (
          <div className="flex justify-center items-center h-24">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
          </div>
        ) : aboutIntro ? (
          <div className="lg:mt-[200px] flex flex-col items-center justify-center lg:gap-6 transition-all duration-300">
            <p className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl transition-colors duration-300 hover:text-primary">
              {aboutIntro.section_title}
            </p>
            <p className="font-nastaleeqRegular text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/90">
              {aboutIntro.section_content}
            </p>
            {aboutIntro.image && (
              <img
                src={`${websiteUrl}/aboutImage/${aboutIntro.image}`}
                alt="about"
                className="mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto mt-4"
              />
            )}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-8">
            کوئی تعارف دستیاب نہیں
          </div>
        )}
        {/*
                <div className="lg:mt-[200px] flex flex-col items-center justify-center lg:gap-6 transition-all duration-300">
                    <p className='font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl transition-colors duration-300 hover:text-primary'>کتابوں سے آشنائی</p>
                    <p className='font-nastaleeqRegular text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/90'>انجمن مشتاقان نور کتابوں سے تعلیمات اہلبیت کے سیکھنے اور پڑھنے کے ماحول کی حوصلہ افزائی اور فروغ دیتی ہے۔ اس سلسلے میں ہم نے ماہر مصنفین، علمائے کرام اور کتب کے ماہرین کی لکھی ہوئی چند کتابیں شائع کی ہیں تاکہ معصومین کا علم اردو میں پڑھنے کی خالص صورت میں فراہم کیا جا سکے۔</p>
                </div>
                */}
        <div className="bg-primaryBG flex flex-col items-center gap-y-8 py-10 px-10 lg:px-[121px] rounded-3xl mt-12 mb-12">
          <p className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl">
            ہماری چند کتب
          </p>
          <div className="flex flex-wrap flex-row-reverse justify-center gap-6 w-full">
            {[book1, book2, book3, book3, book3, book3].map((book, index) => (
              <div
                key={index}
                className="flex flex-col gap-4 items-center w-[150px] cursor-pointer"
              >
                <img
                  src={book}
                  alt={`Book ${index + 1}`}
                  className="h-[200px] w-[129px] object-cover rounded-md transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
                  loading="lazy"
                />
                <p className="text-lg sm:text-xl md:text-xl lg:text-2xl text-center transition-all duration-300 hover:text-primary">
                  عصر غیبت کی ذمہ داریاں
                </p>
                <p className="text-md sm:text-lg md:text-lg lg:text-xl text-center text-[#4C4C4C] transition-all duration-300 hover:text-primary/80">
                  مصنف کا نام
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Mutabaat;
